import { render } from "./PriceScreen.vue?vue&type=template&id=3258ffd9&scoped=true"
import script from "./PriceScreen.vue?vue&type=script&lang=js"
export * from "./PriceScreen.vue?vue&type=script&lang=js"

import "./PriceScreen.vue?vue&type=style&index=0&id=3258ffd9&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3258ffd9"]])

export default __exports__